import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDropdownPosition]'
})
export class DropdownPositionDirective {
  private dropdownElement: HTMLElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('document:click', ['$event'])
  onToggleDropdown(event: MouseEvent) {
    setTimeout(() => this.positionDropdown(), 0);
  }

  private positionDropdown(): void {
    if (!this.dropdownElement) {
      this.dropdownElement = this.el.nativeElement.querySelector('.dropdown-menu');
    }

    if (this.dropdownElement) {
      const elementRect = this.dropdownElement.getBoundingClientRect();
      const rightSpace = window.innerWidth - elementRect.right;
      const leftSpace = elementRect.left;

      if (rightSpace < elementRect.width && leftSpace >= elementRect.width) {

        this.renderer.setStyle(this.dropdownElement, 'left', 'auto');
        this.renderer.setStyle(this.dropdownElement, 'right', '100%');
      } else {

        this.renderer.setStyle(this.dropdownElement, 'right', 'auto');
        this.renderer.setStyle(this.dropdownElement, 'left', '100%');
      }
    }
  }
}
